import React from 'react'
import { useAccess } from 'contexts/access'
import { useOrganization } from 'contexts/organization'
import { useSmartEntity } from 'contexts/smart-entity'
import TiptapOutput from 'components/tiptap/output'
import {
    Main,
    SkeletonTitle, SkeletonH2, SkeletonParagraph, SkeletonStrings,
    CloseButton,
    ImageLogo, Content, Body
} from '../s'
import { Title } from 'components/typography/heading'

const PreviewSmartDocumentContent = ({ only = false, includeLogo, modal }) => {
    const { checkFeature } = useAccess()
    const customLogoAccess = checkFeature('company-logo')
    const { organization = {} } = useOrganization()

    const {
        entity: dokument,
        instated,

        interpolate
    } = useSmartEntity()

    const content = !!dokument?.content?.length ?
        interpolate(dokument.content.flatMap(({ content }) => content)) :
        null

    return (
        <Main>
            {only && <CloseButton onClick={modal.dismiss} />}
            <Content>
                {(!instated) && (
                    <>
                        <SkeletonTitle />
                        <SkeletonH2 />
                        <SkeletonParagraph>
                            <SkeletonStrings count={4} />
                        </SkeletonParagraph>
                        <SkeletonParagraph>
                            <SkeletonStrings />
                        </SkeletonParagraph>
                        <SkeletonParagraph>
                            <SkeletonStrings count={2} />
                        </SkeletonParagraph>
                        <SkeletonParagraph className="indent">
                            <SkeletonStrings count={3} />
                        </SkeletonParagraph>
                        <SkeletonParagraph>
                            <SkeletonStrings count={4} />
                        </SkeletonParagraph>
                    </>
                )}
                {(instated && content) && (
                    <>
                        {(!!customLogoAccess && includeLogo && organization?.companyLogo) && (
                            <ImageLogo logo={organization.companyLogo} />
                        )}
                        <TiptapOutput
                            content={content}
                            overrides={{ h1: [Title] }}
                            element={Body} />
                    </>
                )}
            </Content>
        </Main>
    )
}

export default PreviewSmartDocumentContent